import { useEffect, useState } from "react"
import { View } from "react-native"
import Robot from "@/assets/clipart/techny-chatbot-robot.svg"
import RobotBlink from "@/assets/clipart/techny-chatbot-robot-blink.svg"

export default function BlinkingRobot() {
  const [blinking, setBlinking] = useState(false)

  useEffect(() => {
    let time = 250
    if (!blinking) {
      time = Math.floor(Math.random() * (2700 - 1000 + 1)) + 1000
    }

    const timeId = setTimeout(() => {
      setBlinking((blink) => !blink)
    }, time)

    return () => {
      clearTimeout(timeId)
    }
  }, [blinking])

  return (
    <View>
      <View className="top-0 left-0">
        <Robot width={41} height={30} />
      </View>

      {blinking && (
        <View className="absolute top-0 left-0">
          <RobotBlink width={41} height={30} />
        </View>
      )}
    </View>
  )
}
